

export default function ChildSafetyPolicyPage() {
  return (
    <main className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <img
              src="/logo.jpeg"
              alt="Carz Bazzar Logo"
              width={120}
              height={60}
              className="mx-auto mb-4"
            />
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Child Safety Policy</h1>
            <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Purpose</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              This Child Safety Policy outlines how Carz Bazzar protects children and minors in all our business operations, including our franchise network, website, and customer interactions.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. Age Restrictions</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Our franchise services and website are intended for individuals who are at least 18 years old. Minors under 18 may not engage in franchise agreements or business transactions without verified parental or guardian consent and supervision.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Parental Supervision</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Parents and guardians are encouraged to supervise their child's interactions with our franchise services. We recommend setting appropriate restrictions and guiding minors to understand our business operations responsibly.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Contact Us</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">If you have questions or concerns about this Child Safety Policy, please reach out to us:</p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700 mb-2"><strong>Email:</strong> carsbazzarmain@gmail.com</p>
              <p className="text-gray-700 mb-2"><strong>Phone:</strong> +91 9773460662</p>
              <p className="text-gray-700"><strong>Address:</strong> Carz Bazzar Franchise, India</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
